export default class GambleModel {

  constructor() {
    this._data = {
      maxTries: 0,
      card: null,
      isGamble: false,
      startGamble: false,
      winCard: null,
      history: null,
      totalbet: 0,
      rest: null,
      win: 0,
      total: 0,
      endWin: 0,
    }
  }

  /** @value {number} */
  setStartGamble(value) {
    this._data.startGamble = value
  }

  getStartGamble(){
    return this._data.startGamble
  }

  get() {
    return this._data
  }
  getCard(){
    return this._data.card
  }
  /** @value {number} */
  setCard(value) {
    this._data.card = value
  }

  getIsGamble(){
    return this._data.isGamble
  }

  getMaxTries(){
    return this._data.maxTries
  }
  /** @value {number} */
  setIsGamble(value){
    this._data.isGamble = value
  }
  /** @value {obj} */
  set(value) {

    if(value.settings){
      if(value.settings.gamble){
        this._data.maxTries = value.settings.gamble.maxTries || 0
      }
      else{
        this._data.maxTries = 0
      }
    }

    if(value.context.freespins && value.context.freespins.win){
      this._data.win = value.context.freespins.win || 0
    }
    else if(value.context.win) {
      this._data.win = value.context.win.total || 0
      this._data.endWin =  value.context.win.total || 0
    }
    else if( value.context.gamble) {
      this._data.win = value.context.debit
      this._data.endWin = 0
    }
    else{
      this._data.win = 0
      this._data.endWin = 0
    }

    if (value.context.gamble) {
      this._data.winCard = value.context.gamble.matrix[0][0]
      this._data.history = value.context.gamble.history
      this._data.totalbet = value.context.gamble.totalbet
      this._data.rest = value.context.gamble.rest
      this._data.total = value.context.gamble.total
    }
    else {
      this._data.winCard = null
      this._data.history = null
      this._data.totalbet =  0
      this._data.total =  null
      this._data.rest =  null
    }

    value.context.actions.forEach((action) => {
      if(action === 'double'){
        this._data.isGamble = true
      }
    })

  }
}
